import { useCallback } from 'react';
import { ElementLanes } from '../types';
import { CustomEvents } from '@/libs/eventBus/constants';
import { SelectionOutlineAction } from '@/App/remotion/components/Outlines/types';
import EventBus from '@/libs/eventBus/eventBus';

interface UseElementInteractionsProps {
  elementLanes: ElementLanes;
  draggingElementId: string | null;
  fps: number;
  seekTo: (time: number) => void;
}

export const useElementInteractions = ({
  elementLanes,
  draggingElementId,
  fps,
  seekTo
}: UseElementInteractionsProps) => {
  const handleElementClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>, id: string) => {
      e.stopPropagation();

      if (draggingElementId) {
        return;
      }

      const element = elementLanes.flat().find(el => el.id === id);
      if (!element) {
        return;
      }

      const middleFrame = (element.fromFrame + element.toFrame) / 2;
      seekTo(middleFrame / fps);

      EventBus.dispatch(CustomEvents.SelectionOutlineAction, {
        action: SelectionOutlineAction.SELECT,
        elementType: element.type,
        data: { elementId: id, type: element.type }
      });
    },
    [elementLanes, draggingElementId, fps, seekTo]
  );

  return {
    handleElementClick
  };
};
